var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.getValue,"label":_vm.$t('components.size_selector.label'),"loading":_vm.loading,"items":_vm.sizes,"item-text":"name","item-value":"id","outlined":""},on:{"change":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }